export class Participante {
    participanteid: number;
    nome: string;
    email: string;
    genero: string;
    cpf: string;
    datanascimento: string;
    idade: number;
    racacor: string;
    municipioid: number;
    escolaridade: string;
    pretendeparticiparoficinappa: number;
    pretendeparticiparoficinappadescricao: string;
    desejareceberatualizacao: number;
    tipoparticipante: string;
    senha: string;
    areatematicadebater: number;
}